import dynamic from "next/dynamic";

export const TeamCards = dynamic(() => import("./component"));
